import { Timestamp } from "firebase/firestore";

/* ---------- Enums ---------- */

export const WAVE_SIZES = {
  flat: { label: "Flat", order: 0 },
  knee: { label: "Knee High", order: 1 },
  waist: { label: "Waist High", order: 2 },
  chest: { label: "Chest High", order: 3 },
  head: { label: "Head High", order: 4 },
  overhead: { label: "Overhead", order: 5 },
  double_oh: { label: "Double Overhead+", order: 6 },
} as const;

export const CONDITIONS = {
  clean: { label: "Clean", color: "#2E5D4A" },
  fair: { label: "Fair", color: "#4A5A68" },
  choppy: { label: "Choppy", color: "#E5541B" },
  blown_out: { label: "Blown Out", color: "#C8331F" },
} as const;

export const CROWD_LEVELS = {
  empty: { label: "Empty", color: "#2E5D4A" },
  light: { label: "Light", color: "#4A5A68" },
  moderate: { label: "Moderate", color: "#E5541B" },
  packed: { label: "Packed", color: "#C8331F" },
} as const;

export type WaveSize = keyof typeof WAVE_SIZES;
export type Condition = keyof typeof CONDITIONS;
export type CrowdLevel = keyof typeof CROWD_LEVELS;

/* ---------- Documents ---------- */

export interface SurfReport {
  id: string;
  regionId: string;
  cameraId: string | null;
  cameraName: string | null;
  userId: string;
  userDisplayName: string;
  userPhotoURL: string | null;
  waveSize: WaveSize;
  conditions: Condition;
  crowd: CrowdLevel;
  comment: string | null;
  mediaURL: string | null;
  mediaType: "photo" | "video" | null;
  confirmCount: number;
  denyCount: number;
  likeCount: number;
  createdAt: Timestamp;
}

export interface Vote {
  reportId: string;
  userId: string;
  voteType: "confirm" | "deny";
  createdAt: Timestamp;
}

export interface UserProfile {
  displayName: string;
  photoURL: string | null;
  reportCount: number;
  createdAt: Timestamp;
  lastActiveAt: Timestamp;
}
